import styled from 'styled-components';

export default styled.span`
  text-decoration: ${props => (props.active ? 'underline' : 'none')};
`;



// WEBPACK FOOTER //
// ./app/styled-components/Text.js